import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { ContactFormProps } from 'types/umbraco';
import ContactFormBlockContent from './ContactFormBlockContent';

const ContactFormBlock = ({ heading, isCompany, showContact, contentType, bgColor, textColor }: ContactFormProps): JSX.Element => {
    return (
        <GoogleReCaptchaProvider reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY} language="sv">
            <ContactFormBlockContent heading={heading} isCompany={isCompany} showContact={showContact} contentType={contentType} bgColor={bgColor} textColor={textColor} />
        </GoogleReCaptchaProvider>
    )
}

export default ContactFormBlock